import regionLevel from './regionLevel'
import countryLevel from './countryLevel'

const geoJSON = {
  regionLevel,
  countryLevel
}

export default geoJSON



// WEBPACK FOOTER //
// ./src/utils/geoJSON/geoJSON.js